import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import TransitionPage from 'containers/TransitionPage'
import { addTestAutomationClassName } from 'utils/misc'
import BackButton from 'components/atoms/buttons/BackButton'
import EditDetailsForm from 'components/organisms/EditDetailsForm'

export const styles = theme => ({
  root: {
    width: 328,
    margin: '0 auto',
    ...theme.components.accountPage,
  },
  title: {
    marginBottom: theme.spacing(4),
  },
  logo: {
    marginBottom: theme.spacing(6),
  },
  backButton: {
    ...theme.components.backButton,
  },
})

const EditDetails = ({
  classes,
  errorMessage,
  onFormSubmit,
  hasError,
  onBackPress,
  initialValues,
}) => (
  <TransitionPage>
    <div className={classes.root}>
      <Typography className={classes.title} variant="h1">
          Edit Profile
      </Typography>
      <EditDetailsForm
        onFormSubmit={onFormSubmit}
        apiCallError={hasError}
        errorMessage={errorMessage}
        initialValues={initialValues}
      />
      <BackButton
        onPress={onBackPress}
        className={classNames(
          classes.backButton,
          addTestAutomationClassName('qa-editdetails-button-back')
        )}
      />
    </div>
  </TransitionPage>
)

EditDetails.propTypes = {
  hasError: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  onBackPress: PropTypes.func,
  onFormSubmit: PropTypes.func,
  errorMessage: PropTypes.string,
  initialValues: PropTypes.object,
  actions: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(EditDetails)



// WEBPACK FOOTER //
// ./src/containers/account/EditDetails/EditDetails.js